import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { ProspectusComponent } from './components/prospectus/prospectus.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppService } from './app.service';
import { ProspectusService } from './services/prospectus.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import '@fmr-ap109253/providence/dist/pvd-icon/pvd-icon';
import '@fmr-ap109253/providence/dist/tabs/tab';
import '@fmr-ap109253/providence/dist/tabs/tab-panel';
import '@fmr-ap109253/providence/dist/tabs/tabs';
import '@fmr-ap109253/providence/build/providence';
import { ErrorComponent } from './components/error/error.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { TailoredShareholdersComponent } from './components/tailored-shareholders/tailored-shareholders.component';

@NgModule({ declarations: [
        AppComponent,
        ProspectusComponent,
        ErrorComponent,
        PaginationComponent,
        TailoredShareholdersComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule], providers: [
        AppService,
        ProspectusService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
